import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom';

const Go = () => {
    const { subDomain } = useParams();
    const navigate = useNavigate();
    console.warn(subDomain)
    const getSubDomain = () => {
        if (subDomain != '') {
            localStorage.setItem('wap_user_tenant_sub_domain', subDomain);
            navigate('/');
        }
    }
    useEffect(() => {
        getSubDomain();
    }, []);
}

export default Go;